import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import useWelcomeState from "../../hooks/useWelcomeState";
import { isImpersonating } from "../../lib/policyConsentRules";
import { isWelcomeTarget, shouldRedirectToWelcome } from "../../lib/welcomeRules";
import { setRolloutGateOpen } from "../../lib/rolloutGate";

// ============================================================================
// 로그인 뒤 「새로운 레이블리」 페이지로 — UserLayout 에 마운트(기획 docs/ops/new-laeebly-welcome-plan.md §6)
// app_config.welcome_2026.enabled 이고 대상(isWelcomeTarget — role 비어 있음 포함)이며 아직 「동의하고 새 레이블리 시작」을 누르지 않았으면 /welcome 으로 보낸다.
// 조회 실패·스위치 꺼짐·대리 접속·제외 경로는 아무것도 하지 않는다(기존 게이트 4개가 평소처럼 뒤를 받친다).
// ProtectedRoute(🔴 보호 코드)는 건드리지 않는다.
// 판정하는 동안(loading) rolloutGate 를 열어 홈 코치마크가 먼저 시작하지 않게 한다.
// ============================================================================
export default function WelcomeRedirect() {
  const { userInfo } = useUser();
  const location = useLocation();
  const email = userInfo?.email;
  const role = userInfo?.role;
  const target = Boolean(email) && isWelcomeTarget(role) && !isImpersonating();
  const { state, loading } = useWelcomeState(email, { enabled: target });

  const redirect = target && shouldRedirectToWelcome(state, { role, pathname: location.pathname, impersonating: isImpersonating() });
  const pending = target && loading;
  useEffect(() => {
    setRolloutGateOpen(pending || redirect);
    return () => setRolloutGateOpen(false);
  }, [pending, redirect]);

  if (!redirect) return null;
  return <Navigate to="/welcome" replace />;
}
